import {Route} from 'entity-manager';
import {AbstractSetting} from './abstract-setting';

@Route('default_settings')
export class DefaultSetting extends AbstractSetting {

}
